import React from "react"
import { DateRangePickerSeeker, disabledAfterToday } from "@ui-seeker/core"


export default function BatchDateFilter({ onChange, value }) {
	return <DateRangePickerSeeker
		label="Date Range"
		shouldDisableDate={disabledAfterToday()}
		value={value}
		onChange={onChange}
		preventOverflow={false}
		placement="bottomStart"
	/>
}